<template>
  <div class="water-quality-chart">
    <h3 class="text-center mb-4">{{ title }}</h3>
    <div class="chart-container">
      <apexchart
        type="bar"
        :options="chartOptions"
        :series="chartSeries"
        height="400"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { request } from "@/api/all";

export default {
  name: "WaterQualityChart",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    title: {
      type: String,
      default: "2025 онд мэргэшлийн зэргийн хүчинтэй хүгацаа дуусч буй"
    }
  },
  data() {
    return {
      chartSeries: [],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false
          }
        },
        colors: ["#4299E1", "#FF69B4"],
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
            dataLabels: {
              position: "center"
            }
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#fff"]
          },
          formatter: function(val) {
            return val > 0 ? val : "";
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: [],
          title: {
            text: "Хүний тоо"
          }
        },
        yaxis: {
          title: {
            text: "Мэргэшлийн хүрээгээр"
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " хүн";
            }
          }
        },
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          labels: {
            colors: ["#4299E1", "#FF69B4"]
          }
        }
      }
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      request({
        api: {
          url: "/reportV2/Export",
          method: "POST"
        },
        data: {
          procName: "egazar_chart11",
          exportMode: 2,
          params: []
        }
      }).then(res => {
        if (res != false) {
          console.log("egazar_chart11 data:", res.data);
          this.updateChartData(res.data);
        }
      });
    },
    updateChartData(data) {
      if (data && data.length > 0) {
      // Салбараар групплах
      const groupedByDepart = this.groupByDepartment(data);

      // Салбарын нэрсийг categories болгох
      const categories = Object.keys(groupedByDepart);

      // Мэргэшсэн болон Зөвлөх-ийн датаг тусгаарлах
        const mergeshsenData = [];
        const zovlohData = [];
        
        categories.forEach(depart => {
          const departData = groupedByDepart[depart];
          mergeshsenData.push(departData["Мэргэшсэн"] || 0);
          zovlohData.push(departData["Зөвлөх"] || 0);
        });
        
      // Chart серийг шинэчлэх
        this.chartSeries = [
          {
            name: "Зөвлөх инженер",
            data: zovlohData
          },
          {
            name: "Мэргэшсэн инженер",
            data: mergeshsenData
          }
        ];
        
      // Chart options-ийн categories-ийг шинэчлэх
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            ...this.chartOptions.xaxis,
            categories: categories
          }
        };
      }
    },
    groupByDepartment(data) {
      const grouped = {};

      data.forEach(item => {
        const department = item.depart;
        const name = item.name;
        const count = parseInt(item.count);
        
        if (!grouped[department]) {
          grouped[department] = {};
        }

        if (!grouped[department][name]) {
          grouped[department][name] = 0;
        }

        grouped[department][name] += count;
      });

      return grouped;
    }
  }
};
</script>

<style scoped>
.water-quality-chart {
  padding: 20px;
}

.chart-container {
  max-width: 100%;
  overflow-x: auto;
}
</style>
